"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _CaseReq = _interopRequireDefault(require("./CaseReq"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The CaseNew model module.
 * @module model/CaseNew
 * @version 1.0.0
 */
var CaseNew = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>CaseNew</code>.
   * @alias module:model/CaseNew
   */
  function CaseNew() {
    _classCallCheck(this, CaseNew);

    CaseNew.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(CaseNew, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>CaseNew</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CaseNew} obj Optional instance to populate.
     * @return {module:model/CaseNew} The populated <code>CaseNew</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new CaseNew();

        if (data.hasOwnProperty('case')) {
          obj['case'] = _CaseReq.default.constructFromObject(data['case']);
        }
      }

      return obj;
    }
  }]);

  return CaseNew;
}();
/**
 * @member {module:model/CaseReq} case
 */


CaseNew.prototype['case'] = undefined;
var _default = CaseNew;
exports.default = _default;